import { Outlet } from 'react-router-dom';
import { UsersProvider } from '../contexts/UsersContext';

/**
 * Wrapper component that provides UsersContext to user-related routes
 * This ensures UsersContext is only accessible to user pages, not other pages like Courses
 */
export function UsersRoutes() {
  return (
    <UsersProvider>
      <Outlet />
    </UsersProvider>
  );
}

